import type { FoldAxis, Grid } from "../types.ts";

export interface FoldLineHover {
  axis: FoldAxis;
  line: number;
}

const HIT_WIDTH = 20;

export function detectFoldLineHit(
  mx: number,
  my: number,
  grid: Grid,
  offsetX: number,
  offsetY: number,
  cellSize: number
): FoldLineHover | null {
  // Horizontal fold lines
  for (let line = 1; line < grid.rows; line++) {
    const lineY = offsetY + line * cellSize;
    if (
      Math.abs(my - lineY) < HIT_WIDTH / 2 &&
      mx >= offsetX &&
      mx <= offsetX + grid.cols * cellSize
    ) {
      return { axis: "horizontal", line };
    }
  }

  // Vertical fold lines
  for (let line = 1; line < grid.cols; line++) {
    const lineX = offsetX + line * cellSize;
    if (
      Math.abs(mx - lineX) < HIT_WIDTH / 2 &&
      my >= offsetY &&
      my <= offsetY + grid.rows * cellSize
    ) {
      return { axis: "vertical", line };
    }
  }

  return null;
}
